import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/classNames.ts';

type UnsplashCreditProps = {
  photographerName: string;
  photographerUrl?: string | null;
  sourceUrl?: string | null;
  className?: string;
};

const UNSPLASH_REFERRAL_URL = 'https://unsplash.com/?utm_source=journi&utm_medium=referral';

const UnsplashCredit: FC<UnsplashCreditProps> = ({ photographerName, photographerUrl, sourceUrl, className }) => {
  const { t } = useTranslation();

  return (
    <p className={cn('text-xs leading-4', className)}>
      {t('tripPage.photo_by')}{' '}
      {photographerUrl ? (
        <a href={photographerUrl} target="_blank" rel="noreferrer" className="underline underline-offset-2">
          {photographerName}
        </a>
      ) : (
        photographerName
      )}{' '}
      {t('tripPage.photo_on')}{' '}
      <a
        href={sourceUrl ?? UNSPLASH_REFERRAL_URL}
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-2"
      >
        Unsplash
      </a>
    </p>
  );
};

export default UnsplashCredit;
